import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { publicAPI, userAPI } from '../lib/api';
import { Button } from './ui/button';

export default function AgreementModal() {
  const { user, recordAgreementAcceptance } = useAuth();
  const [agreement, setAgreement] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const isLocked = Boolean(user) && Number(user?.agreement_version_accepted || 0) < 11;
  useEffect(() => {
    if (!isLocked) return undefined;
    let active = true;
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    publicAPI.getCurrentAgreement().then(({ data }) => {
      if (!active) return;
      if (data?.version_id !== 11 || !data?.text || !data?.sha256 || !data?.terms_key) throw new Error('Unavailable');
      setAgreement(data);
    }).catch(() => { if (active) setError('The agreement could not be loaded. Please refresh and try again.'); });
    return () => { active = false; document.body.style.overflow = previous; };
  }, [isLocked]);
  if (!isLocked) return null;
  const handleAccept = async () => {
    if (!agreement) return;
    setSubmitting(true);
    setError('');
    try {
      const { data } = await userAPI.acceptAgreement(agreement);
      recordAgreementAcceptance(data?.agreement_version_accepted);
    } catch (err) {
      setError(err.response?.data?.detail || err.message || 'Failed to accept agreement.');
    } finally { setSubmitting(false); }
  };
  return (
    <div className="fixed inset-0 z-[100] bg-black/95 backdrop-blur-sm">
      <div className="mx-auto flex h-full max-w-6xl flex-col px-4 py-6">
        <h1 className="mb-4 font-unbounded text-xl text-white">Master Agreement — Version 10.1</h1>
        <div className="grid flex-1 overflow-hidden rounded-3xl border border-white/10 bg-surface lg:grid-cols-[1.25fr_0.75fr]">
          <div className="overflow-y-auto p-6">
            {agreement ? <pre className="whitespace-pre-wrap break-words font-sans text-sm leading-7 text-gray-300">{agreement.text}</pre> : <p className="text-gray-400">Loading the complete agreement…</p>}
          </div>
          <div className="overflow-y-auto border-t border-white/10 p-6 lg:border-l lg:border-t-0">
            <p className="text-white">{user?.email}</p>
            <h2 className="mt-6 text-lg text-white">Review and accept Version 10.1</h2>
            <p className="mt-3 text-sm leading-7 text-gray-300">Review the complete agreement before accepting. Your acceptance and the agreement version will be recorded.</p>
            {error && <p role="alert" className="mt-4 text-sm text-red-300">{error}</p>}
            <Button type="button" onClick={handleAccept} disabled={submitting || !agreement} className="mt-5 w-full bg-[#0070f3] text-white">{submitting ? 'Accepting...' : 'Accept'}</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
